import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

type Transition = {
  retry: () => void;
};

type Blocker = (tx: Transition) => void;

/**
 * Block in-app navigation (React Router v6 + BrowserRouter) with a confirm dialog.
 *
 * NOTE: Uses UNSAFE_NavigationContext since the data-router hooks aren't used here.
 */
export function usePrompt(message: string, when: boolean) {
  const { navigator } = useContext(NavigationContext) as unknown as {
    navigator: { block: (blocker: Blocker) => () => void };
  };

  useEffect(() => {
    if (!when) return;
    if (typeof navigator?.block !== 'function') return;

    const unblock = navigator.block((tx) => {
      const ok = window.confirm(message);
      if (!ok) return;
      unblock();
      tx.retry();
    });

    return unblock;
  }, [message, navigator, when]);
}
